import {
  type Challenge,
  type ChallengeSummary,
  type SetComplexImmerStateAction,
  type Task,
  type TaskSummary,
} from '@/lib/types';
import { createContext } from 'react';

const PortfolioItemContext = createContext<{
  portfolioItem: Challenge | Task;
  setPortfolioItem: SetComplexImmerStateAction<Challenge | Task>;
  setPortfolioItemSummary: SetComplexImmerStateAction<
    ChallengeSummary | TaskSummary
  >;
  portfolioItemApiEndpoint: string;
}>({
  portfolioItem: null as unknown as Challenge | Task,
  setPortfolioItem: () => {},
  setPortfolioItemSummary: () => {},
  portfolioItemApiEndpoint: '',
});

export default PortfolioItemContext;
